import { render, staticRenderFns } from "@/components/Layout/Menu/Administracion/Administracion_clientes/Crear_clientes/Crear_clientes.html?vue&type=template&id=fc3d508e&scoped=true&"
import script from "@/components/Layout/Menu/Administracion/Administracion_clientes/Crear_clientes/Crear_clientes.js?vue&type=script&lang=js&"
export * from "@/components/Layout/Menu/Administracion/Administracion_clientes/Crear_clientes/Crear_clientes.js?vue&type=script&lang=js&"
import style0 from "@/components/Layout/Menu/Administracion/Administracion_clientes/Crear_clientes/Crear_clientes.css?vue&type=style&index=0&id=fc3d508e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc3d508e",
  null
  
)

export default component.exports